import { BaseModel } from "@/models/base.model"
import { type IFileRelation } from "@/interfaces/api/file-relation.interface"
import { File } from "@/models/file/file.model"
import { FileUploadContexts } from "@/enums/file-upload-contexts"
import { ModelFactory } from "@/factories/model-factory"

export class FileRelation extends BaseModel implements IFileRelation {
  public static className = "FileRelation" // Used for socket communication.
  public static verboseName = "file relation"

  file: File

  fileBucket: string

  unsavedBucketId: string

  context: FileUploadContexts

  createdBy: string

  constructor(fileRelation: IFileRelation, managed = false) {
    super(fileRelation)

    this.file = ModelFactory.childModel(File, fileRelation.file, managed)
    this.fileBucket = fileRelation.fileBucket
    this.unsavedBucketId = fileRelation.unsavedBucketId
    this.context = fileRelation.context
    this.createdBy = fileRelation.createdBy
  }
}
